import script from "./esAppointmentTypeSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./esAppointmentTypeSettings.vue?vue&type=script&setup=true&lang=ts"

import "./esAppointmentTypeSettings.vue?vue&type=style&index=0&id=30198ba9&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30198ba9"]])

export default __exports__